import { gql } from "@apollo/client";

export const GET_CLUSTER_INFO = gql`
  query ($cluster: String!) {
    ecscluster(cluster: $cluster) {
      name
      version
      lastDeployed
      currentTask
      latestTask
      desiredCount
      pendingCount
      runningCount
    }
  }
`;
